const STORAGE_KEY = "qrce.auth";
const AUTH_CHANGED_EVENT = "qrce-auth-changed";

function notifyAuthChanged() {
    if (typeof window === "undefined") return;
    window.dispatchEvent(new Event(AUTH_CHANGED_EVENT));
}

function safeParseJson(value) {
    if (!value) return null;
    try {
        return JSON.parse(value);
    } catch {
        return null;
    }
}

export function getAuth() {
    if (typeof window === "undefined") return null;
    const raw = window.localStorage.getItem(STORAGE_KEY);
    const parsed = safeParseJson(raw);
    if (parsed && typeof parsed === "object") return parsed;
    return null;
}

export function setAuth(auth) {
    if (typeof window === "undefined") return;
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(auth ?? null));
    notifyAuthChanged();
}

export function clearAuth() {
    if (typeof window === "undefined") return;
    window.localStorage.removeItem(STORAGE_KEY);
    notifyAuthChanged();
}

export function updateAuth(patch) {
    const current = getAuth() || {};
    setAuth({ ...current, ...(patch || {}) });
}

export function getUserId() {
    return getAuth()?.userId || null;
}

export function getAccessToken() {
    return getAuth()?.accessToken || null;
}

export function isAuthenticated() {
    return Boolean(getAccessToken());
}

export function clearAccessTokenKeepUser() {
    const userId = getUserId();
    if (!userId) {
        clearAuth();
        return;
    }
    setAuth({ userId });
}

export function redirectToAuth(reason) {
    if (typeof window === "undefined") return;
    const userId = getUserId();
    if (!userId) {
        window.location.assign("/auth");
        return;
    }
    const url = `/auth?auth=${encodeURIComponent(userId)}${reason ? `&reason=${encodeURIComponent(reason)}` : ""}`;
    window.location.assign(url);
}

export function onAuthChanged(handler) {
    if (typeof window === "undefined") return () => {};
    window.addEventListener(AUTH_CHANGED_EVENT, handler);
    return () => window.removeEventListener(AUTH_CHANGED_EVENT, handler);
}
